export const FETCH_LOAD_TRASH_OWNER_REQUEST = 'FETCH_LOAD_TRASH_OWNER_REQUEST'
export const FETCH_LOAD_TRASH_OWNER_SUCCESS = 'FETCH_LOAD_TRASH_OWNER_SUCCESS'
export const FETCH_LOAD_TRASH_OWNER_FALUIRE = 'FETCH_LOAD_TRASH_OWNER_FALUIRE'
